import { render, staticRenderFns } from "./VehicleDetailsForm.vue?vue&type=template&id=398c2d43&scoped=true"
import script from "./VehicleDetailsForm.vue?vue&type=script&lang=js"
export * from "./VehicleDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./VehicleDetailsForm.vue?vue&type=style&index=0&id=398c2d43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398c2d43",
  null
  
)

export default component.exports